import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'chat-details-header',
  templateUrl: './chat-details-header.component.html',
  styleUrls: ['./chat-details-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatDetailsHeaderComponent {
  @Input() title?: string;
  @Output() close = new EventEmitter<void>();

  onClickCloseButton() {
    this.close.emit();
  }
}
